// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__34Re0","approved":"Status_approved__3JFxi","rejected":"Status_rejected__3Hvc6","expired":"Status_expired__3FnOH","label":"Status_label__1h8V4"};